<template>
  <section>
    <div class="transparent">
      <el-table
        :data="tableData"
        style="width: 100%"
        :header-row-class-name="'tableHeader'"
        @row-click="rowClick">
        <el-table-column
          width="69px"
          align="center">
          <template #default="{ row }">
            <div class="flex-column  flex-align-center">
              <span
                v-if="row.merchant_platform"
                class="table-icon__img mg-b-8">
                <img :src="getOptionName('serverTypeIcon',row.merchant_platform)" >
              </span>
              <p class="icon icon-text">
                <font-awesome-icon
                  icon="file-powerpoint"
                  class="icon-color fs-16"
                  :class="{
                    'green': row.effectiveness == 2,
                    'red': row.effectiveness == 3
                  }" />
              </p>
            </div>
          </template>
        </el-table-column>

        <el-table-column
          width="85px"
          label="Updated">
          <template #default="{ row }">
            <div class="flex-algin time-text">
              <span>{{ row.created_at.split(" ")[0] }}</span><br>
              <span> {{ row.created_at.split(" ")[1] }}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column
          width="70">
          <template #default="{ row }">
            <div class="flex-algin">
              <span>
                <div
                  class="flex table-icon"
                  :class="{'ju_center': row.company_id == 0}">
                  <div v-if="row.company_id">
                    <span
                      v-tooltip="row.company_language"
                      class="icon icon-content">
                      <img
                        :src="getOptionData('companySmallIcon', row.company_id).logo? getOptionData('companySmallIcon', row.company_id).logo: row.company_logo">
                    </span>
                  </div>
                  <div>
                    <span
                      v-tooltip="row.class_language"
                      class="icon icon-content"
                    >
                      <font-awesome-icon
                        v-if="row.class_id"
                        :icon="getOptionName('iconOptions', row.class_id)" />
                    </span>
                  </div>
                </div>
                <div class="flex table-icon margin-top-flex">
                  <div>
                    <span
                      v-if="(Array.isArray(row.extra_benefits) && row.extra_benefits.includes(2)) && extra_show(row.extra_benefits_content,2)==2"
                      v-tooltip="extra_tip(row.extra_benefits_content,2)"
                      class="icon icon-content backgroud-width"
                    >
                      <font-awesome-icon
                        icon="wind" />
                    </span>
                  </div>
                  <div>
                    <span
                      v-if="(Array.isArray(row.extra_benefits) && row.extra_benefits.includes(1)) && extra_show(row.extra_benefits_content,1)==1"
                      v-tooltip="extra_tip(row.extra_benefits_content,1)"
                      class="icon icon-content backgroud-width"
                    >
                      <font-awesome-icon
                        icon="user-injured" />
                    </span>
                  </div>
                </div>
              </span>
            </div>
          </template>
        </el-table-column>

        <el-table-column
          label="Plan Name">
          <template #default="{ row }">
            <div
              class="flex-algin">
              <router-link
                class="showLick"
                :to="rowClickFn(row)">
                <span class="span-label">{{ row.insurer }} {{ row.class_id>50?row.product_type:row.plan}}</span>
              </router-link>
              <p
                v-if="row.pcy_no||row.cvr_nt_no"
                class="phone-text">
                <span  v-if="row.pcy_no"><span class="weight-text">Policy No. </span> {{ row.pcy_no }}&nbsp;&nbsp;&nbsp;</span>
                <span  v-if="row.cvr_nt_no"><span class="weight-text">CN# </span> {{ row.cvr_nt_no }}</span>
              </p>
              <span
                v-if="row.order_sn"
                class="phone-text">
                <template><span class="weight-text"> Ref. </span>{{ row.order_sn }}</template>
              </span>
            </div>
          </template>
        </el-table-column>

        <el-table-column
          width="105px"
          label="Summary">
          <template #default="{ row }">
            <div class="flex-algin">
              <p class="first-text summary">{{ row.description }} </p>
              <!--              <span v-if="row.rgtn_no">-->
              <!--                <span class="summary_rgtn_no">{{ row.rgtn_no }} </span>-->
              <!--              </span>-->
            </div>
          </template>
        </el-table-column>

        <el-table-column
          width="105px"
          label="Policyholder">
          <template #default="{ row }">
            <div class="flex-algin">
              <span class="span-name">{{ row.policy_holder }}</span>
              <span>
                <template v-if="row.identity == 2">
                  {{ row.contact_nm }}
                </template>
                <span class="phone-text"> {{ row.phone_no }}</span>
              </span>
              <p v-if="[0,1].includes(row.pcy_agreement_1)">
                <span class="flex flex-align-center">
                  <font-awesome-icon
                    icon="square-check"
                    class="mg-r-3 fs-12"
                    :class="{'pending_verify-color':row.pcy_agreement_1==0,'verified-color':row.pcy_agreement_1==1} "></font-awesome-icon>
                  <span
                    class="fs-12"
                    :class="{
                      'pending_verify-color': row.pcy_agreement_1 ==0,
                      'verified-color': row.pcy_agreement_1 == 1,
                    }">{{getOptionName('user_agreement_option',row.pcy_agreement_1) }}</span>
                </span>
              </p>
            </div>
          </template>
        </el-table-column>

        <el-table-column
          width="89px"
          :show-overflow-tooltip="true"
          label="Assignee"
          prop="assigne">
          <template #default="{ row }">
            <div class="flex-algin">
              <p class="first-text">{{ row.assigne }} </p>
              <span></span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          width="89px"
          label="Referrer"
        >
          <template #default="{ row }">
            <div class="flex-algin">
              <p class="first-text">
                <span
                  v-if="row.referrer_id != 0 && !row.agent_nm"
                  class="unname">Unnamed</span>
                <span v-if="row.referrer_id != 0">{{ row.agent_nm }}</span>
              </p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          width="95"
          label="Period">
          <template #default="{ row }">
            <div class="flex-algin period-text">
              <span>{{ row.policy_period.split(" - ")[0] }}&nbsp;-</span><br>
              <span> {{ row.policy_period.split(" - ")[1] }}</span>
            </div>
          </template>

        </el-table-column>

        <el-table-column
          width="155px"
          label="Status & Tags">
          <template #default="{ row }">
            <div class="flex-algin">
              <p class="status-height">
                <span
                  class="span-status"
                  :class="{
                    'red': [801, 0].includes(row.stts),
                    'orange': [401, 301].includes(row.stts),
                    'yellow-dark': [410, 501, 701].includes(row.stts),
                    'blue': [420, 505, 705].includes(row.stts),
                    'green': [425, 510, 710].includes(row.stts)
                  }">
                  {{ row.stts_language }}
                </span>
              </p>
              <p
                v-for="(v,i) in row.tag_language"
                :key="i"
                class="status-height">
                <span
                  class="span-options"
                  :class="{
                    'gold': v.id == 1,
                    'blue': [2,16,64,256].includes(v.id),
                    'orange': v.id == 4,
                    'black': [8,32,128].includes(v.id),
                    'red': [512].includes(v.id),
                    'gray': [1024].includes(v.id)
                  }">{{v.name}}</span>
              </p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          width="155px"
          label="Auto Renew">
          <template #default="{ row }">
            <div class="flex-algin">
              <p
                v-if="row.auto_renewal_tag>0"
                class="status-height">
                <span
                  class="span-options"
                  :class="{
                    'gold': [2].includes(row.auto_renewal_tag),
                    'blue': [4].includes(row.auto_renewal_tag),
                    'black': [1].includes(row.auto_renewal_tag),
                    'red': [3].includes(row.auto_renewal_tag),
                  }">{{ getOptionName('auto_renewal_tag_list',row.auto_renewal_tag) }}</span>
              </p>
              <p class="status-height">
                <span
                  class="span-options-2"
                  :class="{
                    'green': row.auto_renewal_on === 1,
                    'gray': row.auto_renewal_on === 2
                  }">{{ getOptionName('auto_renewal_list',row.auto_renewal_on) }}</span>
              </p>

            </div>
          </template>
        </el-table-column>
      </el-table>

      <v-pagination
        :total="pageConfig.total"
        :current="pageConfig.currentPage"
        @currentChange="currentChange" />
    </div>
  </section>
</template>

<script>
import {getRenewalList} from '@/api/renewal'
import MixinOptions from '@/mixins/options'
import {downloadFile} from '@/utils/download'

export default {
  name: 'UnquoteList',
  mixins: [MixinOptions],
  props:{
    filterData:{
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      tableData: [],
      pageConfig: {
        currentPage: 1,
        total: 10
      },
    }
  },
  computed:{
    extra_show(){
      return (row,index)=>{
        let textData = {}
        if(!row) return ''
        Object.entries(row).filter(item=>{
          if(item[1].id == index)
            textData = item[1]
        })
        return textData.id
      }
    },
    extra_tip(){
      return (row,index)=>{
        let textData = {}
        Object.entries(row).filter(item=>{
          if(item[1].id == index)
            textData = item[1]
        })
        if(textData){
          return textData.name
        }
      }
    }
  },
  mounted(){
    this.network().getRenewalList()
  },
  methods: {
    rowClick(row){
      const { id, product_id,pcy_id,sme_versions } = row
      let path = product_id>50&&product_id!=80&&sme_versions!=3?'/records/policy/manual/detail':'/records/policy/detail'
      this.$router.push({
        path: path,
        query: {
          id,
          product_id,
          pcy_id,
          sme_versions
        }
      })
    },

    rowClickFn(row){
      const { id, product_id,pcy_id,sme_versions } = row
      let path = product_id>50&&product_id!=80&&sme_versions!=3?'/records/policy/manual/detail':'/records/policy/detail'
      return({
        path: path,
        query: {
          id,
          product_id,
          pcy_id,
          sme_versions
        }
      })
    },

    currentChange(page) {
      this.pageConfig.currentPage = page
      this.network().getRenewalList()
    },

    network(){
      return {
        getRenewalList: async (otherParams) => {
          let params = {
            type: 1,
            page: this.pageConfig.currentPage,
            ...this.filterData,
            ...otherParams
          }
          if(otherParams && otherParams.is_export == 1){
            const res= await getRenewalList(params,{
              responseType: 'blob',
              timeout: 120000
            })
            downloadFile(res)
          }else{
            const {data} = await getRenewalList(params)
            this.pageConfig.currentPage = data.current_page
            this.pageConfig.total = data.total
            this.tableData = data.data
          }
        }
      }
    }
  },
}
</script>
<style lang='scss' scoped>
.page-container {
  position: relative;
  color: #303133;
  .flex-algin {
    &.time-text{
      font-size: 12px;
    }
    .icon-text{
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      display: flex;
      align-items: center;
      letter-spacing: -0.15px;
      color: #24292E;
      margin-left: 15px;
    }
    .phone-text{
      font-size: 12px;
      color: #6A737D;
      .weight-text{
        font-weight: 600;
      }
    }
    &.period-text{
      span{
        font-size: 12px;
      }
    }
    p, span {
      min-height: 20px;
    }
    .first-text{
      color: #24292E;
      font-size: 14px;
    }
    .summary{
      font-size: 12px;
      word-break: break-word;
    }
    .summary_rgtn_no{
      color: #6A737D;
      font-size: 12px;
      border: 1px solid #6A737D;
      border-radius: 4px;
      padding: 2px 4px;
    }
    .status-height{
      height: 23px;
    }
    .showLick{
      text-decoration: none;
    }
  }
  .ju_center{
    justify-content: center;
  }
  .table-icon{
    &.margin-top-flex{
      margin-top: 5px;
    }
    .icon{
      margin-right: 10px;
      img{
        height: 22px;
        width: 22px;
      }
    }
    .icon-content{
      height: 22px;
      width: 22px;
      border-radius: 5px;
      background-color: #E1E4E8;
      color: #6A737D;
      font-size: 14px;
      text-align: center;
      line-height: 22px;
      display: flex;
      justify-content: center;
      align-items: center;
      border: 1px solid #e1e4e8;
    }
    .backgroud-width{
      background: #fff!important;
      border: 1px solid #e1e4e8;
    }
  }
  .span-name {
    display: block;
    color: #24292E;
    height: auto!important;
    font-size: 14px;
    word-break: break-word;
  }
  .span-label {
    display: block;
    color: #24292E;
    font-weight: 600;
    word-break: break-word;
    font-size: 14px;
    text-decoration: none;
    &:hover{
      color:  #0366D6;
    }
  }
  .span-status, .span-options {
    display: inline-block;
    padding: 0px 8px;
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
    color: #FFFFFF;
    border-radius: 100px;
    max-width: 140px;
    word-break:keep-all;
    white-space:nowrap;
    height: 18px;
    min-height: 18px !important;
    .svg-inline--fa {
      margin-right: 5px;
      font-size: 14px;
    }
  }
  .span-status{
    &.green {
      background: #28a745;
      color: white;
    }
    &.green-trans {
      background: #DCFFE4;
      color: #22863A;
    }
    &.orange {
      background: #E36209;
      color: white;
    }
    &.yellow-dark {
      background: #DBAB09;
    }
    &.blue {
      background: #0366D6;
    }
    &.red {
      background: #d73a49;
    }
    &.min-green {
      background: #dcffe4;
      color: #28a745;
    }
  }
  .span-options{
    border: 1px solid;
    &.gray {
      border-color: #586069;
      color: #586069;
    }
    &.green {
      border-color: #22863A;
      color: #22863A;
    }
    &.green-trans {
      border-color: #DCFFE4;
      color: #DCFFE4;
    }
    &.red {
      border-color: #D73A49;
      color: #D73A49;
    }
    &.gold {
      border-color: #735C0F;
      color: #735C0F;
    }
    &.blue {
      border-color: #0366D6;
      color: #0366D6;
    }
    &.orange {
      border-color: #C24E00;
      color: #C24E00;
    }
    &.black {
      border-color: #24292E;
      color: #24292E;
    }
  }
  .icon-color{
    &.gray {
      color: #586069;
    }
    &.green {
      color: #22863A;
    }
    &.red {
      color: #D73A49;
    }
  }
}
::v-deep .el-table{
  border-radius: 4px;
  border: 1px solid #E1E4E8;
  tr{
    td{
      padding: 10px 15px 10px 0!important;
      vertical-align: top;
      margin-right: 15px;
     .cell{
       line-height: 23px;
       position: relative;
       height: inherit;
       padding: 0;
     }
    }
  }
}
::v-deep .tableHeader {
  margin-top: 30px;
  background: #F6F8FA !important;
  border-bottom: 1px solid #E1E4E8;

  th {
    background-color: #F6F8FA !important;
    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    letter-spacing: -0.15px;
    padding: 10px 0!important;
    color: #24292E!important;
    .cell{
      padding-left: 0;
    }
  }
  .button-border{
    display: inline-block;
    padding: 0px 10px;
    height: auto;
    font-size: 12px;
    border-radius: 50px;
    border: 1px solid #E1E4E8;
    color: #24292E;
    background: white;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 18px;

  }
}
.verified-color{
  color: #22863a;
}
.pending_verify-color{
  color: #dbab09;
}
</style>
